import { useEffect, useState } from "react";

import { Button } from "atoms/button/Button";
import { TextArea } from "atoms/TextArea";

import { QuizStepProps } from "../useQuestionnaire";

import YesNo from "./components/YesNo";

export const CurrentMedications = (props: QuizStepProps) => {
  const hasError = !!props.errors?.CurrentMedications;
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("CurrentMedicationsQuestion", value);
    props.handleStepData("CurrentMedications", "");
    if (value === "No") {
      setLastUpdate({ key: "CurrentMedicationsQuestion", value });
    }
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex h-full flex-col">
      <p className="pb-4 font-serif text-h3">
        Do you currently take any medications? If so, please include name, dose,
        and frequency of all your medications.
      </p>
      <YesNo
        value={props.data.CurrentMedicationsQuestion}
        onChange={(value) => handleChange(value)}
      />
      <div
        className="mt-4"
        hidden={props.data.CurrentMedicationsQuestion !== "Yes"}
      >
        <TextArea
          label="Current Medications"
          value={props.data.CurrentMedications as string}
          invalid={hasError}
          onChange={(value) =>
            props.handleStepData("CurrentMedications", value)
          }
        />
        {hasError && (
          <p className="mt-2 text-sm text-red">
            Please add information requested above.
          </p>
        )}
      </div>
      <div
        hidden={props.data.CurrentMedicationsQuestion !== "Yes"}
        className="mt-auto"
      >
        <Button fullWidth onClick={props.next}>
          Next Question
        </Button>
      </div>
    </div>
  );
};
